import React from 'react'
import CustomModal from 'components/global/CustomModal'
import { Tabs } from 'antd'
import TabPane from 'antd/lib/tabs/TabPane'
import { leagueAttendanceStore } from 'state/league/leagueAttendance'
import LeagueCheckInOutTab from './Common/LeagueCheckInOutTab'
import LeagueHistoryTab from './Common/LeagueHistoryTab'

const CheckInModal: React.FC = () => {
  const {
    checkInModal,
    setCheckInModal,
    setCheckInOutModalOpen,
    setSelectedAttendee,
  } = leagueAttendanceStore(store => ({
    checkInModal: store.checkInModal,
    setCheckInModal: store.setCheckInModal,
    setCheckInOutModalOpen: store.setCheckInOutModalOpen,
    setSelectedAttendee: store.setSelectedAttendee,
  }))

  const closeModal = () => {
    setSelectedAttendee(null)
    setCheckInModal(false)
    setCheckInOutModalOpen(true)
  }

  return (
    <CustomModal
      openModal={checkInModal}
      isCloseModalCustom
      closeModal={closeModal}
      title="Check-in details"
      width={1200}
      footer={false}
    >
      <>
        <Tabs defaultActiveKey="check-in">
          <TabPane tab="Check-in" key="check-in">
            <LeagueCheckInOutTab type="check-in" />
          </TabPane>
          <TabPane tab="History" key="history">
            <LeagueHistoryTab />
          </TabPane>
        </Tabs>
      </>
    </CustomModal>
  )
}

export default CheckInModal
